let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("lpfAf")]).then(() => parcelRequire('3bb5K'));